import {Form, InputNumber} from "antd";
import {useEffect} from "react";
import initLabelStyles from "./SettingsFormHelper";
import ResultTable from "../Table/ResultTable";
import ResultHeader from "../Table/ResultHeader";
import ResultHeaderCell from "../Table/ResultHeaderCell";
import ResultBody from "../Table/ResultBody";
import ResultBodyCell from "../Table/ResultBodyCell";
import ResultRow from "../Table/ResultRow";
import getSettingsItem from "./SettingsItem";

export default function DecimalPlacesSettings({onValuesChange, values, defValues}) {

    return (
        <>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Variable</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left'}}>User Preference</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left'}}>System Default</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Description</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {
                        getSettingsItem({
                            value: values?.delta_ws,
                            defaultValue: defValues?.delta_ws,
                            onChange: (value) => {onValuesChange('delta_ws', value)},
                            label: 'Surcharge',
                            description: 'T-SRC-001',
                            min: 0,
                            max: 5
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.us_ds_dist,
                            defaultValue: defValues?.us_ds_dist,
                            onChange: (value) => {onValuesChange('us_ds_dist', value)},
                            label: 'Distance',
                            description: 'T-CES-001',
                            min: 0,
                            max: 5
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.us_ds_ratio,
                            defaultValue: defValues?.us_ds_ratio,
                            onChange: (value) => {onValuesChange('us_ds_ratio', value)},
                            label: 'Cont/Exp Ratio',
                            description: 'T-CES-001',
                            min: 0,
                            max: 5
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.reach_channel,
                            defaultValue: defValues?.reach_channel,
                            onChange: (value) => {onValuesChange('reach_channel', value)},
                            label: 'Reach Length',
                            description: 'T-DSRL-001, T-DSRL-001',
                            min: 0,
                            max: 5
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.skew_angle,
                            defaultValue: defValues?.skew_angle,
                            onChange: (value) => {onValuesChange('skew_angle', value)},
                            label: 'Skew Angle',
                            description: 'T-SKW-001, T-SKW-002, T-CES-01',
                            min: 0,
                            max: 5
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.cutline_ratio,
                            defaultValue: defValues?.cutline_ratio,
                            onChange: (value) => {onValuesChange('cutline_ratio', value)},
                            label: 'Cutline Ratio, r',
                            description: 'T-XCL-002',
                            min: 0,
                            max: 5
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.flow_rate,
                            defaultValue: defValues?.flow_rate,
                            onChange: (value) => {onValuesChange('flow_rate', value)},
                            label: 'Flow Rate',
                            description: 'T-HYD-001, T-FLW-001',
                            min: 0,
                            max: 5
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.wsel,
                            defaultValue: defValues?.wsel,
                            onChange: (value) => {onValuesChange('wsel', value)},
                            label: 'WSEL',
                            description: 'T-WSEL-001, T-WSEL-ICS-001',
                            min: 0,
                            max: 5
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.reach_length,
                            defaultValue: defValues?.reach_length,
                            onChange: (value) => {onValuesChange('reach_length', value)},
                            label: 'Reach Length (miles)',
                            description: 'Plan Summary',
                            min: 0,
                            max: 5
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.top_width,
                            defaultValue: defValues?.top_width,
                            onChange: (value) => {onValuesChange('top_width', value)},
                            label: 'Top Width',
                            description: 'T-SRC-001',
                            min: 0,
                            max: 5
                        })
                    }
                </ResultBody>
            </ResultTable>
        </>
    )
}

const getRule = (message) => {
    return [{ required: true, message: message }]
}